import React from 'react';
import PropTypes from 'prop-types';

import StringUtils from '../../../services/StringUtils';
import Select from '../../Select/Select';
import MenuItem from '../../MenuItem/MenuItem';
import { defaultOperatorByType } from './constants';

const style = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 85,
    width: 250,
    marginRight: 10,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  select: {
    width: 175,
    marginLeft: 10,
  },
};

export class ChargerComponentOperatorSelector extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (props.fieldName !== state.fieldName || !StringUtils.isJson(props.value)) {
      const value = { ...defaultOperatorByType.chargerPackage };

      props.onChange(JSON.stringify(value));

      return {
        fieldName: props.fieldName,
        value,
      };
    }

    try {
      const value = JSON.parse(props.value);

      if (state.value.name === value.name && state.value.version === value.version) {
        return null;
      }

      return { value };
    } catch (e) {
      return {
        value: { ...defaultOperatorByType.chargerPackage },
      };
    }
  }

  state = {
    fieldName: this.props.fieldName,
    value: { ...defaultOperatorByType.chargerPackage },
  };

  onNameChange = (event) => {
    const value = JSON.stringify({
      name: event.target.value,
      version: this.state.value.version,
    });

    this.props.onChange(value);
  };

  onVersionChange = (event) => {
    const value = JSON.stringify({
      name: this.state.value.name,
      version: event.target.value,
    });

    this.props.onChange(value);
  };

  render() {
    const options = this.props.options.map(({ name, label, color }) => (
      <MenuItem key={name} value={name}>
        <span>
          <div className="query-builder-operator-indicator" style={{ backgroundColor: color }} />
          {label}
        </span>
      </MenuItem>
    ));

    return (
      <div style={style.root} className="query-builder-value-charger-selector">
        <div style={style.row} className="charger-package__field">
          Name
          <Select value={this.state.value.name} onChange={this.onNameChange} style={style.select}>
            {options}
          </Select>
        </div>
        <div style={style.row} className="charger-package__field">
          Version
          <Select value={this.state.value.version} onChange={this.onVersionChange} style={style.select}>
            {options}
          </Select>
        </div>
      </div>
    );
  }
}

ChargerComponentOperatorSelector.propTypes = {
  fieldName: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.array,
  onChange: PropTypes.func,
};
